// extracted by mini-css-extract-plugin
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var sectionContainer = "QuoteContainer-module--sectionContainer--2gnbn";